---
fr:
  portfolio_stats:
    aggregated_intraday_hourly_revenue: Revenu horaire intraday agrégé
    click_to_refresh: Cliquez ici pour actualiser
    heading: Statistiques du portefeuille
    hourly_revenue: Revenu horaire
    hourly_revenue_warning: Graphique du revenu horaire désactivé lorsqu'il y a plus de 200 centrales électriques
    monthly_revenue: Revenu mensuel
    of_budget: du budget
    portfolio_production: Aperçu de la production du portefeuille
    portfolio_total: Total du portefeuille
    power_plant_age_distribution: Répartition de l'âge des centrales
    power_plants_yearly_load_hour: Heures à pleine charge (total annuel)
    prod_and_runoff_vs_normal: Production et écoulement vs. normal
    prod_vs_bud: Production vs. budget
    prod_vs_normal: Production vs. normal
    prod_vs_normal_ytd: Production vs. normal YTD
    production_ytd: Production YTD
    rev_and_bud: Revenu et budget
    rev_and_bud_ytd: Revenu et budget YTD
    rev_vs_bud: Revenu vs. budget
    rev_vs_bud_ytd: Revenu vs. budget YTD
    revenue_ytd: Revenu YTD
    runoff_vs_average: Écoulement vs. moyenne
    runoff_vs_normal_ytd: Production et écoulement vs. normal YTD
    technical_downtime: Aperçu de l'interruption technique
